import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';


@Metamodel.model({})
export class Compression {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_CompressionType,
        constraint: {
            allowed: ['BZip2', 'Deflate', 'GZip', 'ZipDeflate']
        }
    })
    public compressionType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CompressionLabel,
        constraint: {
            allowed: ['Fastest', 'Optimal']
        }
    })
    public compressionLevel?: string;
}
